import {
  DATA_PRODUCT_VIEW,
  SET_DM_CHAT_OPEN,
  SET_DM_PRODUCTS
} from '../types/dataMarketPlaceConstants'

const initialState = {
  view: 'grid',
  isChatOpen: false,
  products: []
}

const dataMarketPlaceReducer = (state = initialState, action) => {
  switch (action.type) {
    case DATA_PRODUCT_VIEW:
      return {
        ...state,
        view: action.payload
      }

    case SET_DM_CHAT_OPEN:
      return {
        ...state,
        isChatOpen: action.payload
      }

    case SET_DM_PRODUCTS:
      return {
        ...state,
        products: action.payload
      }

    default:
      return state
  }
}

export default dataMarketPlaceReducer
